/* Living.Fit v3 cart enhancements (page + drawer). Works on top of the theme's own cart.js re-render.
   Baymard: #2151 auto-update qty, #2157/#622 save for later, undo remove, #732/#2320 shipping estimate,
   #603/#1490 added-to-cart confirmation with View cart + Continue shopping, #601 drawer behaviors. */
(function () {
  'use strict';
  if (window.__lfCartV3) return; window.__lfCartV3 = 1;

  var CART_URL = (window.routes && window.routes.cartUrl) || '/cart';
  var SAVE_KEY = 'lf_saved_v1', ZIP_KEY = 'lf_zip_v1';
  var cache = null, lastCartEl = null, lastSig = '', rateState = { zip: '', rates: [], pick: '' };
  var flagSave = null, toastTimer = null, addTimer = null;

  try { if (/[?&]lfdrawer=1/.test(location.search)) sessionStorage.setItem('lfdrawer', '1'); if (/[?&]lfdrawer=0/.test(location.search)) sessionStorage.removeItem('lfdrawer'); } catch (e) {}

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function el(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function sess(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function pageEl() { return $('.lfcart[data-lf-cart-page]'); }
  function drawerEl() { return document.getElementById('sidebar-cart'); }
  /* Main-cart writes own this gate; never infer completion from a timer or total. */
  function createCheckoutGate() {
    var pending = 0, holds = {}, failed = false, tail = Promise.resolve(), desired = {}, controls = new WeakMap(), activity = 0;
    function blocked() { return pending > 0 || Object.keys(holds).length > 0 || failed; }
    function clearPendingUI(b, old) {
      var ui=old && old.pendingUI;if(!ui || !ui.active)return;
      if(ui.label.parentNode===b && ui.label.childElementCount===0 && ui.label.textContent===ui.pendingText)ui.label.textContent=ui.text;
      if(b.getAttribute('aria-busy')==='true'){if(ui.ariaBusy===null)b.removeAttribute('aria-busy');else b.setAttribute('aria-busy',ui.ariaBusy);}
      if(b.getAttribute('data-lf-cart-pending')==='true'){if(ui.marker===null)b.removeAttribute('data-lf-cart-pending');else b.setAttribute('data-lf-cart-pending',ui.marker);}
      ui.active=false;
    }
    function pendingUI(b,old) {
      if(failed){clearPendingUI(b,old);return;}
      if(!old.pendingUI){
        var pendingPage=pageEl(), pendingText=pendingPage && pendingPage.getAttribute('data-lf-reconcile-pending');
        if(!pendingText || !pendingText.trim())return;
        if(b.tagName!=='BUTTON' || !b.matches('.cart__submit') || old.disabled || old.aria==='true' || b.hasAttribute('data-lf-cart-pending'))return;
        var labels=Array.prototype.filter.call(b.children,function(n){return n.tagName==='SPAN' && n.childElementCount===0;});
        if(labels.length!==1)return;
        old.pendingUI={label:labels[0],text:labels[0].textContent,ariaBusy:b.getAttribute('aria-busy'),marker:null,pendingText:pendingText,active:false,retired:false};
      }
      var ui=old.pendingUI;if(ui.retired)return;
      if(ui.active){
        if(ui.label.parentNode!==b || ui.label.childElementCount!==0 || ui.label.textContent!==ui.pendingText || b.getAttribute('aria-busy')!=='true' || b.getAttribute('data-lf-cart-pending')!=='true'){clearPendingUI(b,old);ui.retired=true;}
        return;
      }
      ui.label.textContent=ui.pendingText;b.setAttribute('aria-busy','true');b.setAttribute('data-lf-cart-pending','true');ui.active=true;
    }
    function paint() {
      var page = pageEl(); if (!page) return;
      var busy = blocked();
      function control(b) {
        if (busy) { if (!controls.has(b)) controls.set(b,{disabled:b.disabled,aria:b.getAttribute('aria-disabled')}); if ('disabled' in b)b.disabled=true; b.setAttribute('aria-disabled','true'); pendingUI(b,controls.get(b)); }
        else if (controls.has(b)) { var old=controls.get(b); clearPendingUI(b,old); if ('disabled' in b)b.disabled=old.disabled; if(old.aria===null)b.removeAttribute('aria-disabled');else b.setAttribute('aria-disabled',old.aria); controls.delete(b); }
      }
      $$('.cart__submit', page).forEach(control);
      $$('[data-lfstick] a').forEach(control);
      var msg = $('[data-lf-checkout-state]', page);
      if (!msg) { msg = el('p', 'lfcs__msg'); msg.setAttribute('data-lf-checkout-state', ''); msg.setAttribute('role', 'status'); msg.setAttribute('aria-live', 'polite'); page.appendChild(msg); }
      var text = failed ? 'A cart update did not finish. Reload the cart before checking out.' : busy ? 'Saving your cart. Checkout will be available when your changes finish.' : '';
      if (msg.textContent !== text) msg.textContent = text;
      msg.hidden = !text;
    }
    function hold(key) { if(key !== 'reconcile') activity++; holds[key] = (holds[key] || 0) + 1; paint(); var done = false; return function(ok) { if (done) return; done = true; if(key !== 'reconcile' && ok !== false) document.dispatchEvent(new CustomEvent('lf:cart-owner-will-settle')); if (--holds[key] <= 0) delete holds[key]; if (ok === false) failed = true; paint(); if(key !== 'reconcile') document.dispatchEvent(new CustomEvent('lf:cart-owner-settled')); }; }
    function run(key, work) {
      if (!pageEl()) return Promise.resolve().then(work);
      activity++; pending++; paint();
      var job = tail.then(work);
      tail = job.catch(function() {});
      return job.then(function(v) { document.dispatchEvent(new CustomEvent('lf:cart-owner-will-settle')); pending--; if (!pending) desired = {}; paint(); document.dispatchEvent(new CustomEvent('lf:cart-owner-settled')); return v; }, function(e) { pending--; failed = true; if (!pending) desired = {}; paint(); throw e; });
    }
    /* A discount can rotate a Shopify line key. Resolve only a unique full identity. */
    var identities = Object.create(null), epochs = Object.create(null), transitioning = Object.create(null);
    function version(key) { return epochs[key] || 0; }
    function acceptVersion(key) { return transitioning[key] ? -1 : version(key); }
    function rendered() { transitioning=Object.create(null); }
    function canonical(value) {
      if (Array.isArray(value)) return value.map(canonical);
      if (value && typeof value === 'object') return Object.keys(value).sort().map(function(k){return [k,canonical(value[k])];});
      return value;
    }
    function lineIdentity(line, planOverride, hasOverride) {
      var plan = hasOverride ? planOverride : line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id;
      return JSON.stringify([String(line.variant_id),plan ? String(plan) : '',canonical(line.properties || {})]);
    }
    function resolveLine(key, acceptedVersion) {
      if (acceptedVersion !== undefined && acceptedVersion !== version(key)) return Promise.reject(new Error("Cart line changed after this edit; reload before checking out"));
      return fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw new Error('Cart unavailable');return r.json();}).then(function(cart){
        var items=cart.items||[], exact=items.filter(function(i){return i.key===key;}), signature=identities[key], line;
        if(exact.length===1){line=exact[0];signature=lineIdentity(line);}
        else if(!exact.length&&signature){var matches=items.filter(function(i){return lineIdentity(i)===signature;});if(matches.length===1)line=matches[0];}
        if(!line)throw new Error('Cart line is no longer uniquely identifiable');
        if(items.filter(function(i){return lineIdentity(i)===signature;}).length!==1)throw new Error('Cart line identity is ambiguous');
        items.forEach(function(item){var sig=lineIdentity(item);if(items.filter(function(other){return lineIdentity(other)===sig;}).length===1)identities[item.key]=sig;});
        identities[key]=signature;identities[line.key]=signature;
        return {cart:cart,line:line,signature:signature};
      });
    }
    function confirmLine(before, cart, quantity, planOverride, hasOverride, onConfirmed) {
      var expected=lineIdentity(before.line,planOverride,hasOverride), matches=(cart.items||[]).filter(function(i){return lineIdentity(i)===expected;});
      if(!quantity){if(matches.length)throw new Error('Cart removal was not confirmed');return cart;}
      var expectedQuantity=quantity;
      if(hasOverride&&expected!==before.signature) expectedQuantity+=(before.cart.items||[]).filter(function(i){return i.key!==before.line.key&&lineIdentity(i)===expected;}).reduce(function(n,i){return n+i.quantity;},0);
      if(matches.length!==1||matches[0].quantity!==expectedQuantity)throw new Error('Cart change was not confirmed');
      var fromVersions = Object.create(null);
      if (typeof onConfirmed === 'function') Object.keys(identities).forEach(function(k){if(identities[k]===before.signature)fromVersions[k]=version(k);});
      if (hasOverride && expected !== before.signature) {
        Object.keys(identities).forEach(function(k){if(identities[k]===before.signature||identities[k]===expected){epochs[k]=version(k)+1;transitioning[k]=true;}});
        if (!Object.prototype.hasOwnProperty.call(epochs,matches[0].key)) epochs[matches[0].key]=1;
        transitioning[matches[0].key]=true;
      }
      Object.keys(identities).forEach(function(k){if(identities[k]===before.signature)identities[k]=expected;});
      identities[matches[0].key]=expected;
      if (typeof onConfirmed === 'function') {
        var fromPostVersions=Object.create(null);Object.keys(fromVersions).forEach(function(k){fromPostVersions[k]=version(k);});
        onConfirmed({fromVersions:fromVersions,fromPostVersions:fromPostVersions,toKey:matches[0].key,toVersion:version(matches[0].key)});
      }
      return cart;
    }
    function quantity(key, requested, delta) { var q = requested; if (delta && Object.prototype.hasOwnProperty.call(desired,key)) q = Math.max(0,desired[key]+delta); desired[key] = q; return q; }
    function stop(e) { if (!pageEl() || !blocked()) return; e.preventDefault(); e.stopImmediatePropagation(); paint(); }
    document.addEventListener('submit', function(e) { if (e.target.matches && e.target.matches('.lfcart[data-lf-cart-page] form.Cart')) stop(e); }, true);
    document.addEventListener('click', function(e) { if (e.target.closest && e.target.closest('.lfcart[data-lf-cart-page] .cart__submit,[data-lfstick] a')) stop(e); }, true);
    return {activityVersion:function(){return activity;},idleExcept:function(key){return !failed && pending===0 && Object.keys(holds).every(function(k){return k===key;});},run:run,hold:hold,quantity:quantity,resolveLine:resolveLine,confirmLine:confirmLine,version:version,acceptVersion:acceptVersion,rendered:rendered,paint:paint,blocked:blocked,reject:function(){failed=true;paint();}};
  }
  var checkoutGate = window.lfCartCheckoutGate = createCheckoutGate();
  document.addEventListener('lf:cart-markup-replaced',function(){checkoutGate.paint();});

  /* Read-only reconciliation for a main-cart HTML snapshot. Never replay a mutation. */
  function createCartReconciler() {
    var running = null, release = null, queued = false, requested = false, emitting = false, resumeForm = null, observed = 0;
    /* Liquid serializes properties as pairs; Ajax serializes a name/value map.
       Sort names only. Never trim/coerce values or drop private allocation IDs. */
    function propertyPairs(v) {
      if (v == null) return [];
      var pairs;
      if (Array.isArray(v)) pairs=v;
      else if (typeof v === 'object' && Object.prototype.toString.call(v)==='[object Object]')
        pairs=Object.keys(v).map(function(k){return [k,v[k]];});
      else throw new Error('Invalid cart properties');
      var seen=Object.create(null);
      var out=pairs.map(function(pair){
        if(!Array.isArray(pair) || pair.length!==2 || typeof pair[0]!=='string' || Object.prototype.hasOwnProperty.call(seen,pair[0]))
          throw new Error('Ambiguous cart property');
        seen[pair[0]]=true;
        var value=pair[1];
        if(value!==null && typeof value!=='string' && typeof value!=='boolean' && !(typeof value==='number' && Number.isFinite(value)))
          throw new Error('Invalid cart property value');
        return [pair[0],value];
      });
      return out.sort(function(a,b){return a[0]<b[0]?-1:a[0]>b[0]?1:0;});
    }
    function cents(v) { if (!Number.isSafeInteger(v) || v < 0) throw new Error('Invalid cart amount'); return v; }
    function fingerprint(c) {
      if (!c || !Array.isArray(c.items) || typeof c.currency !== 'string') throw new Error('Missing cart snapshot');
      var lines = c.items.map(function(i) {
        if (!i || typeof i.key !== 'string' || !i.key || !i.variant_id || !Number.isSafeInteger(i.quantity) || i.quantity < 1) throw new Error('Invalid cart line');
        var plan = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan && i.selling_plan_allocation.selling_plan.id;
        return [i.key, String(i.variant_id), plan ? String(plan) : '', propertyPairs(i.properties), i.quantity, cents(i.original_line_price), cents(i.final_line_price)];
      });
      if(c.items.reduce(function(n,i){return n+i.quantity;},0)!==c.item_count)throw new Error('Invalid cart count');
      /* Keep line order: native updates[] fields are positional. Preserve duplicates too. */
      return JSON.stringify([c.currency, cents(c.item_count), cents(c.total_price), cents(c.original_total_price), cents(c.items_subtotal_price), cents(c.total_discount), lines]);
    }
    function form() { var p=pageEl();return p && $('.Cart',p); }
    function snapshot(f) {
      var s=f && $('[data-lf-cart-snapshot]',f);if(!s)throw new Error('Cart snapshot unavailable');
      var c=JSON.parse(s.textContent), inputs=$$('[name="updates[]"]',f);
      if(!Array.isArray(c.items) || inputs.length!==c.items.length)throw new Error('Cart controls do not match');
      c.items.forEach(function(item,i){if(inputs[i].id!=='updates_'+item.key || String(inputs[i].value)!==String(item.quantity))throw new Error('Cart edit is not confirmed');});
      return c;
    }
    function message(key){var p=pageEl();return p ? p.getAttribute('data-lf-reconcile-'+key)||'' : '';}
    function note(text, recover) {
      var p=pageEl();if(!p)return;var n=$('[data-lf-cart-reconcile-state]',p);
      if(!n){n=el('p','lfcs__msg');n.setAttribute('data-lf-cart-reconcile-state','');n.setAttribute('role','status');p.appendChild(n);}
      n.textContent=text;n.hidden=!text;
      if(recover){var a=el('a','lfl',message('reload'));a.href=CART_URL;n.appendChild(document.createTextNode(' '));n.appendChild(a);}
    }
    function read(url, asText) {
      var controller=typeof AbortController!=='undefined'?new AbortController():null, timer;
      var timeout=new Promise(function(resolve,reject){timer=setTimeout(function(){if(controller)controller.abort();reject(new Error('Cart confirmation timed out'));},10000);});
      var request=fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:asText?'text/html':'application/json'},signal:controller?controller.signal:undefined})
        .then(function(r){if(!r.ok)throw new Error('Cart confirmation unavailable');return asText?r.text():r.json();});
      return Promise.race([request,timeout]).finally(function(){clearTimeout(timer);});
    }
    function current(g,f,o){var ok=observed===o &&checkoutGate.activityVersion()===g && checkoutGate.idleExcept('reconcile') && form()===f;if(!ok)requested=true;return ok;}
    function hold(){if(!release)release=checkoutGate.hold('reconcile');}
    function done(){if(release){var r=release;release=null;r(true);}note('',false);}
    function fail(){if(release){var r=release;release=null;r(false);}else checkoutGate.reject();note(message('error'),true);}
    function check() {
      if(!pageEl())return Promise.resolve(false);
      if(running){requested=true;return running;}
      hold();
      if(!checkoutGate.idleExcept('reconcile'))return Promise.resolve(false);
      var g=checkoutGate.activityVersion(), f=form(), o=observed;
      note(message('pending'),false);
      running=read('/cart.js',false).then(function(c){
        if(!current(g,f,o))return false;
        if(fingerprint(snapshot(f))===fingerprint(c)){cache=c;done();return true;}
        return read(CART_URL+'?view=ajax&timestamp='+Date.now(),true).then(function(html){
          if(!current(g,f,o))return false;
          var tmp=document.createElement('div');tmp.innerHTML=html;var next=$('.Cart',tmp), rendered=snapshot(next), expected=fingerprint(rendered);
          return read('/cart.js',false).then(function(latest){
            if(!current(g,f,o))return false;
            if(expected!==fingerprint(latest))throw new Error('Cart changed during confirmation');
            /* No owned edit may be overwritten; replace only the verified form. */
            f.parentNode.replaceChild(next,f);f=next;renderSeq++;
            var p=pageEl(), content=$('.PageContent',p), empty=$('[data-empty-page-content]',p);
            if(content)content.classList.toggle('hide',latest.item_count===0);
            if(empty)empty.classList.toggle('hide',latest.item_count!==0);
            cache=latest;
            emitting=true;
            try{document.dispatchEvent(new CustomEvent('lf:cart-markup-replaced'));fire(latest);onRendered();}finally{emitting=false;}
            if(fingerprint(snapshot(form()))!==fingerprint(latest))throw new Error('Cart rendering did not match');
            done();return true;
          });
        });
      }).catch(function(){if(!current(g,f,o))return false;fail();return false;}).finally(function(){running=null;if(requested){requested=false;queue();}});
      return running;
    }
    function queue(){if(emitting)return;if(running){requested=true;return;}if(queued)return;queued=true;setTimeout(function(){queued=false;if(checkoutGate.idleExcept('reconcile'))check();},0);}
    function changed(){if(emitting)return;observed++;queue();}
    document.addEventListener('lf:cart-updated',changed);
    document.addEventListener('lf:cart-owner-will-settle',function(){if(pageEl())hold();});
    document.addEventListener('lf:cart-owner-settled',changed);
    document.addEventListener('rebuy:cart.change',changed);
    document.addEventListener('visibilitychange',function(){if(!document.hidden)queue();});
    document.addEventListener('submit',function(e){
      var f=form();if(!f || e.target!==f || e.defaultPrevented)return;
      if(resumeForm===f){resumeForm=null;return;}
      var button=e.submitter || $('.cart__submit',f);
      if(!button || !button.matches('.cart__submit') || checkoutGate.blocked())return;
      e.preventDefault();e.stopImmediatePropagation();var g=checkoutGate.activityVersion(), o=observed;
      check().then(function(ok){
        if(!ok || observed!==o || checkoutGate.activityVersion()!==g || checkoutGate.blocked())return;
        var latest=form(), submit=latest && $('.cart__submit',latest);
        if(!submit || submit.disabled || typeof latest.requestSubmit!=='function'){fail();return;}
        resumeForm=latest;try{latest.requestSubmit(submit);}finally{resumeForm=null;}
      });
    },true);
    return {check:check,fingerprint:fingerprint};
  }

  var cartReconciler = createCartReconciler();

  function renderedCart() {
    var page = pageEl(), form = page && $('.Cart[data-lf-cart-total]', page);
    if (!form || !form.hasAttribute('data-lf-cart-count') || !form.hasAttribute('data-lf-cart-items')) return null;
    var total = Number(form.getAttribute('data-lf-cart-total')), count = Number(form.getAttribute('data-lf-cart-count')), items = Number(form.getAttribute('data-lf-cart-items'));
    if (!Number.isFinite(total) || !Number.isFinite(count) || !Number.isFinite(items)) return null;
    return { total_price: total, display_count: count, item_count: items };
  }

  function drawerMode() {
    if (pageEl()) return false; var d = drawerEl(); if (!d) return false;
    var t = ''; try { t = JSON.parse(d.getAttribute('data-section-settings')).type; } catch (e) {}
    return t === 'drawer' || sess('lfdrawer') === '1';
  }

  /* ---------- cart data ---------- */
  var cartRead = null, cartReadSeq = 0, renderSeq = 0;
  function getCart() {
    var seq = ++cartReadSeq;
    cartRead = fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); }).then(function (c) {
      if (seq !== cartReadSeq) return cartRead;
      cache = c; return c;
    });
    return cartRead;
  }
  function itemByKey(k) { return cache && cache.items.filter(function (i) { return i.key === k; })[0]; }
  function plainProps(p) { var o = {}; if (p) for (var k in p) { if (p[k] !== '' && p[k] != null) o[k] = p[k]; } return o; }

  /* ---------- re-render (used by undo / move to cart / added-to-cart) ---------- */
  function reloadCartForRender() { checkoutGate.reject(); location.reload(); return new Promise(function(){}); }
  function refreshUI() {
    var render = ++renderSeq, wasEmpty = cache && cache.item_count === 0;
    return getCart().then(function (cart) {
      if (render !== renderSeq) return cart;
      var page = pageEl(), drawer = drawerEl();
      var box = page || drawer;
      if (!box) { fire(cart); return cart; }
      if (page && (wasEmpty || cart.item_count === 0)) return reloadCartForRender();
      return fetch(CART_URL + '?view=' + (page ? 'ajax' : 'drawer') + '&timestamp=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { if(!r.ok)throw new Error('Cart rendering failed');return r.text(); }).then(function (html) {
          if (render !== renderSeq) return cart;
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var oldCart = $('.Cart', box), newCart = $('.Cart', tmp);
          if (!newCart) { if (page) return reloadCartForRender(); return cart; }
          checkoutGate.flushDrafts();
          if (oldCart) {
            var sc = $('.Drawer__Main', box); var pos = sc ? sc.scrollTop : 0;
            oldCart.parentNode.replaceChild(newCart, oldCart);
            sc = $('.Drawer__Main', box); if (sc) sc.scrollTop = pos;
          } else if (drawer) { drawer.innerHTML = tmp.firstElementChild.innerHTML; }
          if (page) document.dispatchEvent(new CustomEvent('lf:cart-markup-replaced'));
          fire(cart); return cart;
        });
    });
  }
  function fire(cart) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('lf:cart-updated', { detail: cart }));
  }

  /* ---------- toast (undo etc.) ---------- */
  function toastEl() {
    var t = $('.lfcart-toast[data-lf-toast]'); if (t) return t;
    t = el('div', 'lfcart-toast'); t.setAttribute('data-lf-toast', ''); t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); t.hidden = true;
    document.body.appendChild(t); return t;
  }
  function toast(msg, actionLabel, action) {
    var t = toastEl(); t.textContent = ''; t.hidden = false;
    t.appendChild(el('span', '', msg));
    if (actionLabel) { var b = el('button', '', actionLabel); b.type = 'button'; b.addEventListener('click', function () { t.hidden = true; action && action(); }); t.appendChild(b); }
    var x = el('button', 'x', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Dismiss'); x.addEventListener('click', function () { t.hidden = true; }); t.appendChild(x);
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 10000);
    t.onmouseenter = function () { clearTimeout(toastTimer); };
  }

  /* ---------- undo remove / save for later ---------- */
  function noteRemoval(key) {
    var item = itemByKey(key); if (!item) return;
    var save = flagSave; flagSave = null;
    var snap = { id: item.variant_id, quantity: item.quantity, properties: plainProps(item.properties), selling_plan: item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id };
    var name = item.product_title || item.title;
    if (save) {
      var list = store(SAVE_KEY) || [];
      list = list.filter(function (s) { return !(s.id === snap.id && JSON.stringify(s.properties) === JSON.stringify(snap.properties)); });
      list.unshift({ id: snap.id, quantity: snap.quantity, properties: snap.properties, selling_plan: snap.selling_plan || null, title: name, vt: (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '', url: item.url, img: item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_144x144$1$2') : '', price: item.final_price });
      store(SAVE_KEY, list.slice(0, 20)); renderSaved();
      toast('Saved for later: ' + name, 'Undo', function () {
        store(SAVE_KEY, (store(SAVE_KEY) || []).filter(function (s) { return s.id !== snap.id; })); renderSaved();
        addBack(snap);
      });
    } else {
      toast('Removed: ' + name, 'Undo', function () { addBack(snap); });
    }
  }
  function addBack(snap, onAdded) {
    var it = { id: snap.id, quantity: snap.quantity }; if (Object.keys(snap.properties || {}).length) it.properties = snap.properties; if (snap.selling_plan) it.selling_plan = snap.selling_plan;
    function restoreItem(){ window.__lfQuiet = true; return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [it] }) })
      .then(function (r) { window.__lfQuiet = false; return r; }, function (e) { window.__lfQuiet = false; throw e; })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        if (onAdded) {
          var rows = j && j.items;
          function props(p) { return JSON.stringify(Object.keys(plainProps(p)).sort().map(function(k){ return [k, String(p[k])]; })); }
          if (!Array.isArray(rows) || rows.length !== 1 || !rows[0] || !isFinite(Number(rows[0].quantity)) || String(rows[0].variant_id || rows[0].id) !== String(snap.id) || Number(rows[0].quantity) < Number(snap.quantity) || props(rows[0].properties) !== props(snap.properties) || String(rows[0].selling_plan_allocation && rows[0].selling_plan_allocation.selling_plan && rows[0].selling_plan_allocation.selling_plan.id || '') !== String(snap.selling_plan || '')) throw new Error('The cart response could not be confirmed. Reload before trying again.');
          onAdded();
        }
        return refreshUI();
      }); }
    return checkoutGate.run('restore', restoreItem)
      .catch(function (e) { toast((e && (e.description || e.message)) || 'Could not add that item back.'); });
  }

  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-lf-save]');
    if (s) {
      e.preventDefault(); flagSave = true;
      var li = s.closest('.CartItem'); var rm = li && $('[data-action="remove-item"]', li);
      if (!itemByKey(s.getAttribute('data-line-id'))) { getCart().then(function () { noteRemovalLater(s.getAttribute('data-line-id'), rm); }); return; }
      noteRemovalLater(s.getAttribute('data-line-id'), rm); return;
    }
    var a = e.target.closest('[data-action="remove-item"], [data-action="update-item-quantity"]');
    if (a && a.getAttribute('data-quantity') === '0' && !a.__lfSkip) noteRemoval(a.getAttribute('data-line-id'));
  }, true);
  function noteRemovalLater(key, rm) { noteRemoval(key); if (rm) { rm.__lfSkip = true; rm.click(); } }

  /* qty field: sanitize, select on focus, auto-update after a short pause, 0 = remove with undo */
  document.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('.QuantitySelector__CurrentQuantity')) { try { e.target.select(); } catch (x) {} } });
  var qtyDrafts = new Map();
  checkoutGate.intentVersion = function(i,key){var d=qtyDrafts.get(i);return d?d.version:checkoutGate.acceptVersion(key);};
  checkoutGate.finishDraft = function(i,ok){finishDraft(i,ok);};
  checkoutGate.flushDrafts = function(){Array.from(qtyDrafts.keys()).forEach(function(i){if(i.value==='')finishDraft(i,false);else sendDraft(i);});};
  function finishDraft(i, ok) { var d = qtyDrafts.get(i); if (!d) return; clearTimeout(d.timer); qtyDrafts.delete(i); d.release(ok); }
  function sendDraft(i) { var d = qtyDrafts.get(i); if (!d) return; clearTimeout(d.timer); if (!i.isConnected) { finishDraft(i, false); return; } i.dispatchEvent(new Event('change', { bubbles:true })); }
  document.addEventListener('input', function(e) {
    var i=e.target; if (!(i.matches && i.matches('.QuantitySelector__CurrentQuantity'))) return;
    var v=i.value.replace(/\D/g,''); if(v!==i.value)i.value=v;
    var d=qtyDrafts.get(i); if(d)clearTimeout(d.timer);
    if(v===i.defaultValue){finishDraft(i,true);return;}
    if(!d){d={version:checkoutGate.acceptVersion(i.getAttribute('data-line-id')),release:i.closest('[data-lf-cart-page]')?checkoutGate.hold('draft:'+i.getAttribute('data-line-id')):function(){}};qtyDrafts.set(i,d);}
    if(v!=='')d.timer=setTimeout(function(){sendDraft(i);},300);
  });
  document.addEventListener('keydown', function(e) { var i=e.target; if(e.key==='Enter'&&i.matches&&i.matches('.QuantitySelector__CurrentQuantity')){e.preventDefault();sendDraft(i);} });
  document.addEventListener('change',function(e){var i=e.target;if(i.matches&&i.matches('.QuantitySelector__CurrentQuantity')&&!i.closest('[data-lf-cart-page]'))finishDraft(i,true);},true);
  document.addEventListener('click', function(e) {
    if(!e.target.closest||!e.target.closest('[data-action="update-item-quantity"],[data-action="remove-item"],.cart__submit,[data-lfstick] a'))return;
    Array.from(qtyDrafts.keys()).forEach(sendDraft);
  },true);
  document.addEventListener('change', function (e) {
    var i = e.target; if (!(i.matches && i.matches('.QuantitySelector__CurrentQuantity')) || e.__lfOk) return;
    var n = parseInt(i.value, 10);
    if (isNaN(n) || n < 0) { e.stopImmediatePropagation(); i.value = i.defaultValue; finishDraft(i,true); return; }
    if (n === 0) noteRemoval(i.getAttribute('data-line-id'));
  }, true);

  /* ---------- saved for later list (page) ---------- */
  var savedMoves = Object.create(null);
  function renderSaved() {
    var box = $('[data-lf-saved]'); if (!box) return;
    var list = store(SAVE_KEY) || [], ul = $('[data-lf-saved-list]', box); ul.textContent = '';
    box.hidden = !list.length; if (!list.length) return;
    list.forEach(function (s, idx) {
      var li = el('li', 'lfsv__item');
      var ia = el('a', 'lfsv__img'); ia.href = s.url; ia.tabIndex = -1; ia.setAttribute('aria-hidden', 'true');
      if (s.img) { var im = el('img'); im.src = s.img; im.alt = ''; im.width = 72; im.height = 72; ia.appendChild(im); }
      var mid = el('div'); var t = el('a', 'lfsv__t', s.title); t.href = s.url; mid.appendChild(t);
      if (s.vt) mid.appendChild(el('span', 'lfsv__v', s.vt));
      mid.appendChild(el('span', 'lfsv__p', money(s.price)));
      var act = el('div', 'lfsv__act');
      var add = el('button', 'lfsv__add', 'Move to cart'); add.type = 'button'; add.setAttribute('aria-label', 'Move ' + s.title + ' to cart');
      var moveKey = JSON.stringify(s);
      if (savedMoves[moveKey]) { add.disabled = true; add.textContent = 'Adding…'; }
      add.addEventListener('click', function () {
        if (savedMoves[moveKey]) return;
        savedMoves[moveKey] = true;
        add.disabled = true; add.textContent = 'Adding…';
        addBack(s, function () { var before = store(SAVE_KEY); if (!Array.isArray(before)) throw new Error('The item was added, but saved items could not be updated. Reload before trying again.'); var next = before.filter(function (x) { return JSON.stringify(x) !== JSON.stringify(s); }); store(SAVE_KEY, next); if (JSON.stringify(store(SAVE_KEY)) !== JSON.stringify(next)) throw new Error('The item was added, but saved items could not be updated. Reload before trying again.'); delete savedMoves[moveKey]; renderSaved(); });
      });
      var rm = el('button', 'lfl', 'Remove'); rm.type = 'button'; rm.setAttribute('aria-label', 'Remove ' + s.title + ' from saved items');
      rm.addEventListener('click', function () { var l = store(SAVE_KEY) || []; l.splice(idx, 1); store(SAVE_KEY, l); renderSaved(); });
      act.appendChild(add); act.appendChild(rm);
      li.appendChild(ia); li.appendChild(mid); li.appendChild(act); ul.appendChild(li);
    });
  }

  /* ---------- shipping estimate (page) ---------- */
  function setShip(rate) {
    var rendered = renderedCart();
    var base = rendered ? rendered.total_price : cache ? cache.total_price : +(($('[data-lf-total]') || {}).getAttribute && $('[data-lf-total]').getAttribute('data-lf-base')) || 0;
    var v = $('[data-lf-ship-val]'), n = $('[data-lf-ship-note]'), tot = $('[data-lf-total]'), tn = $('[data-lf-total-note]'), row = $('[data-lf-ship-row]');
    if (!v || !tot) return;
    if (!rate) { v.textContent = '—'; if (n) n.textContent = 'Enter your ZIP below to estimate'; tot.textContent = money(base); if (tn) tn.textContent = 'Before shipping & tax'; row && row.classList.remove('lfcs__row--free'); return; }
    var cents = Math.round(parseFloat(rate.price) * 100);
    v.textContent = cents === 0 ? 'FREE' : money(cents); row && row.classList.toggle('lfcs__row--free', cents === 0);
    if (n) n.textContent = (rate.presentment_name || rate.name) + ' to ' + rateState.zip;
    tot.textContent = money(base + cents); if (tn) tn.textContent = 'Includes shipping · tax at checkout';
  }
  function showRates(silent) {
    var ul = $('[data-lf-rates]'), msg = $('[data-lf-est-msg]'); if (!ul) return; ul.textContent = '';
    if (!rateState.rates.length) { setShip(null); return; }
    rateState.rates.forEach(function (r, i) {
      var cents = Math.round(parseFloat(r.price) * 100); var li = el('li'), lab = el('label'), inp = el('input');
      inp.type = 'radio'; inp.name = 'lf-rate'; inp.value = r.name; inp.checked = (rateState.pick ? rateState.pick === r.name : i === 0);
      inp.addEventListener('change', function () { rateState.pick = r.name; setShip(r); });
      var nm = el('span', '', r.presentment_name || r.name);
      if (r.delivery_days && r.delivery_days.length) { var d = el('span', 'sub', r.delivery_days.length > 1 ? r.delivery_days[0] + '–' + r.delivery_days[r.delivery_days.length - 1] + ' business days' : r.delivery_days[0] + ' business days'); nm.appendChild(d); }
      var p = el('span', 'p', cents === 0 ? 'FREE' : money(cents));
      lab.appendChild(inp); lab.appendChild(nm); lab.appendChild(p); li.appendChild(lab); ul.appendChild(li);
    });
    var sel = rateState.rates.filter(function (r) { return rateState.pick ? r.name === rateState.pick : true; })[0] || rateState.rates[0];
    rateState.pick = sel.name; setShip(sel);
    if (msg && !silent) { msg.className = 'lfcs__msg'; msg.textContent = ''; }
  }
  /* ZIP (first 3 digits) -> state code. Shopify's rate lookup needs a state, and a ZIP implies one. */
  var ZR = [[5,5,'NY'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[889,898,'NV'],[900,961,'CA'],[967,968,'HI'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  function stateForZip(z) { var p = parseInt(z.slice(0, 3), 10); for (var i = 0; i < ZR.length; i++) { if (p >= ZR[i][0] && p <= ZR[i][1]) return ZR[i][2]; } return ''; }
  function estimate(zip, silent) {
    var msg = $('[data-lf-est-msg]'); zip = (zip || '').trim();
    if (!/^\d{5}(-\d{4})?$/.test(zip)) { if (msg && !silent) { msg.className = 'lfcs__msg err'; msg.textContent = 'Please enter a 5-digit U.S. ZIP code.'; } return; }
    var st = stateForZip(zip);
    if (!st) { if (msg && !silent) { msg.className = 'lfcs__msg err'; msg.textContent = 'That ZIP code isn’t one we can estimate for. Shipping is shown at checkout.'; } return; }
    if (msg && !silent) { msg.className = 'lfcs__msg'; msg.textContent = 'Checking shipping options…'; }
    var q = 'shipping_address[zip]=' + encodeURIComponent(zip.slice(0, 5)) + '&shipping_address[country]=US&shipping_address[province]=' + st;
    var tries = 0;
    function poll() {
      return fetch('/cart/async_shipping_rates.json?' + q, { credentials: 'same-origin' }).then(function (r) {
        if (r.status === 202 && tries++ < 12) return new Promise(function (ok) { setTimeout(ok, 600); }).then(poll);
        if (!r.ok) throw new Error('rates');
        return r.json();
      });
    }
    fetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST', credentials: 'same-origin' })
      .then(function (r) { if (!r.ok && r.status !== 202) throw new Error('prep'); return poll(); })
      .then(function (j) {
        var rates = (j && j.shipping_rates || []).slice().sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
        rateState.zip = zip; rateState.rates = rates; sess(ZIP_KEY, zip);
        if (!rates.length && msg) { msg.className = 'lfcs__msg'; msg.textContent = 'Shipping for the items in your cart is calculated at checkout, once you enter your delivery address.'; }
        showRates(silent);
      })
      .catch(function () { if (msg && !silent) { msg.className = 'lfcs__msg err'; msg.textContent = 'We couldn’t estimate shipping right now. Shipping is shown at checkout.'; } });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lf-est-go]')) { e.preventDefault(); estimate(($('[data-lf-zip]') || {}).value); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-lf-zip]')) { e.preventDefault(); estimate(e.target.value); }
  });

  /* ---------- sticky mobile checkout bar (page) ---------- */
  var io = null, stick = null;
  function setupSticky() {
    var page = pageEl(); if (!page) return;
    checkoutGate.paint();
    if (!stick) {
      stick = el('div', 'lfstick'); stick.setAttribute('data-lfstick', '');
      var t = el('div', 'lfstick__t'); t.appendChild(el('small', '', 'Subtotal')); var b = el('b', ''); b.setAttribute('data-lfstick-total', ''); t.appendChild(b);
      var btn = el('a', '', 'Checkout'); btn.href = '/checkout'; btn.setAttribute('role', 'button');
      btn.addEventListener('click', function (e) { e.preventDefault(); var s = $('.cart__submit'); if (s) s.click(); else location.href = '/checkout'; });
      stick.appendChild(t); stick.appendChild(btn); document.body.appendChild(stick);
    }
    var current = renderedCart() || cache;
    var tot = $('[data-lfstick-total]', stick); if (tot && current) tot.textContent = money(current.total_price);
    if (io) io.disconnect();
    var sub = $('.cart__submit');
    if (!sub || !('IntersectionObserver' in window) || !current || !current.item_count) { stick.classList.remove('is-on'); document.body.classList.remove('lf-has-stick'); return; }
    io = new IntersectionObserver(function (en) {
      var on = !en[0].isIntersecting && en[0].boundingClientRect.top > 0 && window.innerWidth < 990;
      stick.classList.toggle('is-on', on); document.body.classList.toggle('lf-has-stick', on);
    }, { threshold: 0 });
    io.observe(sub);
  }

  /* ---------- titles / counts that live outside the re-rendered form ---------- */
  function displayCount(cart) {
    return (cart.items || []).reduce(function (n, item) {
      var rolls = Number(item.properties && item.properties['Roll(s)']);
      return n + (Number.isFinite(rolls) && rolls > 0 ? rolls : Number(item.quantity) || 0);
    }, 0);
  }
  function syncChrome() {
    var current = renderedCart();
    if (!current && !cache) return; var n = current ? current.display_count : displayCount(cache), txt = n ? '(' + n + ' ' + (n === 1 ? 'item' : 'items') + ')' : '';
    $$('.lfcart-title, #sidebar-cart .Drawer__Title').forEach(function (h) {
      var s = $('small', h);
      if (!txt) { if (s) s.remove(); return; }
      if (!s) { s = document.createElement('small'); h.appendChild(s); }
      if (s.textContent !== txt) s.textContent = txt;
    });
  }

  /* ---------- re-apply things after the theme replaces the form ---------- */
  function onRendered() {
    checkoutGate.paint();
    syncChrome(); renderSaved(); setupSticky();
    var page = pageEl();
    if (page && $('[data-lf-est]')) {
      var z = sess(ZIP_KEY) || rateState.zip; var inp = $('[data-lf-zip]'); if (inp && z) inp.value = z;
      if (z) { if (rateState.rates.length && rateState.zip === z) showRates(true); else estimate(z, true); }
    }
  }
  function watch() {
    var box = pageEl() || drawerEl(); if (!box) return;
    new MutationObserver(function () {
      var c = $('.Cart', box); var sig = c ? c.innerHTML.length + ':' + $$('.CartItem', c).length + ':' + c.getAttribute('data-lf-cart-total') + ':' + c.getAttribute('data-lf-cart-count') + ':' + c.getAttribute('data-lf-cart-items') : 'x';
      if (c === lastCartEl && sig === lastSig) return; lastCartEl = c; lastSig = sig;
      if (renderedCart()) { syncChrome(); setupSticky(); }
      getCart().then(onRendered).catch(function () {});
    }).observe(box, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-lf-cart-total', 'data-lf-cart-count', 'data-lf-cart-items'] });
    lastCartEl = $('.Cart', box); lastSig = lastCartEl ? lastCartEl.innerHTML.length + ':' + $$('.CartItem', lastCartEl).length + ':' + lastCartEl.getAttribute('data-lf-cart-total') + ':' + lastCartEl.getAttribute('data-lf-cart-count') + ':' + lastCartEl.getAttribute('data-lf-cart-items') : 'x';
  }

  /* ---------- drawer open/close (Esc, header trigger when in drawer mode) ---------- */
  function openDrawer() {
    var d = drawerEl(); if (!d) return; d.classList.add('show'); document.body.classList.add('show_overlay');
    setTimeout(function () { d.focus(); }, 320);
  }
  function closeDrawer() { var d = drawerEl(); if (d && d.classList.contains('show')) { d.classList.remove('show'); document.body.classList.remove('show_overlay'); } }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-lfh-cart]');
    if (h && drawerMode()) { e.preventDefault(); e.stopPropagation(); refreshUI().then(openDrawer); }
  }, true);

  /* ---------- added-to-cart confirmation (Baymard #603 / #1490) ---------- */
  function showAdded(detail) {
    var items = (detail && detail.items) || (detail && detail.title ? [detail] : []);
    var it = items[0]; if (!it) return;
    if (drawerMode()) {
      refreshUI().then(function () {
        var b = $('[data-lfd-added]'), t = $('[data-lfd-added-text]');
        if (b && t) { t.textContent = (it.product_title || it.title) + ' added to your cart'; b.classList.add('is-on'); setTimeout(function () { b.classList.remove('is-on'); }, 6000); }
        openDrawer();
      }); return;
    }
    if (pageEl()) return;
    var old = $('.lfadd'); if (old) old.remove();
    var c = el('div', 'lfadd'); c.setAttribute('role', 'dialog'); c.setAttribute('aria-label', 'Added to your cart');
    var h = el('p', 'lfadd__h', '✓ Added to your cart');
    var row = el('div', 'lfadd__row');
    if (it.image) { var im = el('img'); im.src = it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2'); im.alt = ''; im.width = 72; im.height = 72; row.appendChild(im); }
    var d = el('div', 'lfadd__d'); d.appendChild(el('b', '', it.product_title || it.title));
    if (it.variant_title && it.variant_title !== 'Default Title') d.appendChild(el('span', '', it.variant_title));
    d.appendChild(el('span', '', 'Qty ' + it.quantity + ' · ' + money(it.final_line_price != null ? it.final_line_price : it.price * it.quantity)));
    row.appendChild(d);
    var btns = el('div', 'lfadd__b');
    var chk = el('a', 'lfb lfb--y', 'View cart & checkout'); chk.href = CART_URL;
    var cont = el('button', 'lfl', 'Continue shopping'); cont.type = 'button'; cont.addEventListener('click', function () { c.remove(); });
    btns.appendChild(chk); btns.appendChild(cont);
    var x = el('button', 'lfadd__x', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Close'); x.addEventListener('click', function () { c.remove(); });
    c.appendChild(x); c.appendChild(h); c.appendChild(row); c.appendChild(btns); document.body.appendChild(c);
    clearTimeout(addTimer); var arm = function () { clearTimeout(addTimer); addTimer = setTimeout(function () { c.remove(); }, 8000); }; arm();
    c.addEventListener('mouseenter', function () { clearTimeout(addTimer); }); c.addEventListener('mouseleave', arm); c.addEventListener('focusin', function () { clearTimeout(addTimer); });
  }
  document.addEventListener('lf:cart-added', function (e) { showAdded(e.detail); });

  /* detect add-to-cart calls (any source) so we can show the confirmation */
  (function () {
    if (!window.fetch || window.__lfFetchPatched) return; window.__lfFetchPatched = 1;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !window.__lfQuiet) {
        p.then(function (r) { if (!r.ok) return; r.clone().json().then(function (j) { document.dispatchEvent(new CustomEvent('lf:cart-added', { detail: j })); }).catch(function () {}); }).catch(function () {});
      }
      return p;
    };
  })();

  /* A restored history snapshot may contain stale totals or suspended cart writes.
     Reload only BFCache-restored main carts; never replay mutations or alter normal entry. */
  var restoreReloading = false;
  window.addEventListener('pageshow', function(e) {
    if (!e.persisted || !pageEl() || restoreReloading) return;
    restoreReloading = true;
    location.reload();
  });

  /* ---------- boot ---------- */
  function boot() {
    if(pageEl()) cartReconciler.check();
    watch();
    if (renderedCart()) { syncChrome(); setupSticky(); }
    if (pageEl() || drawerEl()) getCart().then(onRendered);
    else renderSaved();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();



